import { format, parseISO } from "date-fns";
import { RisorseInfoCorrenti, Tariffe_Calendario } from "../prismaTypes";
import { MILL_PER_MIN } from "./TabellaTariffe";
import { Slot } from "./Slot";

export function getSlots(
  risorsaInfo: RisorseInfoCorrenti | undefined,
  tariffeCalendario: Tariffe_Calendario[]
): Slot[] {
  const slots: Slot[] = [];
  if (
    risorsaInfo &&
    risorsaInfo.oraInizioDisponibilita !== null &&
    risorsaInfo.oraFineDisponibilita !== null
  ) {
    let n = 0;
    let fine = parseISO(risorsaInfo.oraFineDisponibilita.slice(0, -1));
    let ora = parseISO(risorsaInfo.oraInizioDisponibilita.slice(0, -1));
    if (fine < ora) fine = new Date(fine.getTime() + 24 * 3600 * 1000);
    while (ora < fine && n < 150) {
      const next = new Date(ora.getTime() + risorsaInfo.durataSlot * MILL_PER_MIN);

      slots.push({
        id: n,
        text: format(ora, "HH:mm") + " >> " + format(next, "HH:mm"),
        oraInizio: new Date(ora),
        oraFine: new Date(next),
      });

      n++;
      ora = next;
    }
  }
  return slots;
}
